export const FidelityType = {
  COMO: 'como',
  ZEROSIX: 'zerosix',
} as const;

export type FidelityType = (typeof FidelityType)[keyof typeof FidelityType];
